<template>
    <out-put-page title="Étude financière">
        <section>
            <div class="mb-6">
                <h3>
                    Programme d'investissement (HT)
                </h3>
                <div class="grid grid-cols-2">
                    <VueApexCharts
                        class=""
                        type="donut"
                        :series="investorProgrammeSeries"
                        :options="investorProgrammeOptions"
                        height="450px"
                    />
                    <div class="flex flex-col mx-8 space-y-4">
                        <div class="flex flex-col">
                            <div
                                class="flex items-center justify-center p-4 bg-output-primary"
                            >
                                <h4 class="text-2xl font-semibold text-white">
                                    Immobilisations en non-valeur
                                </h4>
                            </div>
                            <div
                                class="flex items-center justify-center p-4 text-2xl text-white bg-output-blue-300"
                            >
                                <h4 class="text-2xl font-semibold text-white">
                                    {{
                                        formatPrice(ImmobilisationsEnNonValeur)
                                    }}
                                </h4>
                            </div>
                        </div>
                        <div class="flex flex-col ">
                            <div
                                class="flex items-center justify-center p-4 bg-output-primary"
                            >
                                <h4 class="text-2xl font-semibold text-white">
                                    Immobilisations corporelles
                                </h4>
                            </div>
                            <div
                                class="flex items-center justify-center p-4 text-2xl text-white bg-output-blue-300"
                            >
                                <h4>
                                    {{
                                        formatPrice(ImmobilisationsCorporelles)
                                    }}
                                </h4>
                            </div>
                        </div>
                        <div class="flex flex-col ">
                            <div
                                class="flex items-center justify-center p-4 bg-output-primary"
                            >
                                <h4 class="text-2xl font-semibold text-white">
                                    Total
                                </h4>
                            </div>
                            <div
                                class="flex items-center justify-center p-4 text-2xl text-white bg-output-blue-300"
                            >
                                <h4>
                                    {{
                                        formatPrice(
                                            investorProgramme.nonValueAssetTotal
                                        )
                                    }}
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <h3>
                    Plan de Financement(HT)
                </h3>
                <div class="flex flex-col ">
                    <div class="grid items-center grid-cols-2 gap-6">
                        <VueApexCharts
                            class="mt-4 "
                            type="donut"
                            :series="seriesPlanFinancement"
                            :options="optionsPlanFinancement"
                            height="550px"
                        />
                        <div class="flex flex-col space-y-3">
                            <div class="flex flex-col">
                                <div
                                    class="flex items-center justify-center p-4 bg-output-primary"
                                >
                                    <h4
                                        class="text-2xl font-semibold text-white"
                                    >
                                        CAPITAL SOCIAL
                                    </h4>
                                </div>
                                <div
                                    class="flex items-center justify-center p-4 text-2xl text-white bg-output-blue-300"
                                >
                                    <h4
                                        class="text-2xl font-semibold text-white"
                                    >
                                        {{
                                            formatPrice(
                                                seriesPlanFinancement[0]
                                            )
                                        }}
                                    </h4>
                                </div>
                            </div>
                            <div class="flex flex-col ">
                                <div
                                    class="flex items-center justify-center p-4 bg-output-primary"
                                >
                                    <h4
                                        class="text-2xl font-semibold text-white"
                                    >
                                        APPORT EN COMPTES COURANTS ASSOCIÉS
                                    </h4>
                                </div>
                                <div
                                    class="flex items-center justify-center p-4 text-2xl text-white bg-output-blue-300"
                                >
                                    <h4>
                                        {{
                                            formatPrice(
                                                seriesPlanFinancement[1]
                                            )
                                        }}
                                    </h4>
                                </div>
                            </div>
                            <div class="flex flex-col ">
                                <div
                                    class="flex items-center justify-center p-4 bg-output-primary"
                                >
                                    <h4
                                        class="text-2xl font-semibold text-white"
                                    >
                                        CRÉDIT BANCAIRE
                                    </h4>
                                </div>
                                <div
                                    class="flex items-center justify-center p-4 text-2xl text-white bg-output-blue-300"
                                >
                                    <h4>
                                        {{
                                            formatPrice(
                                                seriesPlanFinancement[3]
                                            )
                                        }}
                                    </h4>
                                </div>
                            </div>
                            <div class="flex flex-col ">
                                <div
                                    class="flex items-center justify-center p-4 bg-output-primary"
                                >
                                    <h4
                                        class="text-2xl font-semibold text-white"
                                    >
                                        TOTAL
                                    </h4>
                                </div>
                                <div
                                    class="flex items-center justify-center p-4 text-2xl text-white bg-output-blue-300"
                                >
                                    <h4>
                                        {{
                                            formatPrice(
                                                seriesPlanFinancement.reduce(
                                                    (a, b) => a + b
                                                )
                                            )
                                        }}
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <stylish-table :table="{}" /> -->
        </section>
    </out-put-page>
</template>

<script>
import OutPutPage from "../components/OutPutPage";
import VueApexCharts from "vue-apexcharts";
import { OutputHelpers } from "@/mixins/OutputMixin.js";

export default {
    name: "pi-and-pf",
    components: {
        OutPutPage,
        VueApexCharts
    },
    props: {
        investorProgramme: {
            type: Object,
            required: true
        }
    },
    mixins: [OutputHelpers],

    mounted() {
        this.investorProgrammeSeries.push(this.ImmobilisationsEnNonValeur);
        this.investorProgrammeSeries.push(this.ImmobilisationsCorporelles);
        this.seriesPlanFinancement.push(
            this.investorProgramme?.capitalSocial ?? 0
        );
        this.seriesPlanFinancement.push(
            this.investorProgramme?.compteAssocie ?? 0
        );
        this.seriesPlanFinancement.push(this.investorProgramme?.leasing ?? 0);

        //temp variable for compatibility reasons
        const creditBancaireTemp = Array.isArray(
            this.investorProgramme.creditBancaire
        )
            ? this.investorProgramme.creditBancaire
            : [this.investorProgramme.creditBancaire];

        const creditBancaire = creditBancaireTemp.reduce((sum, credit) => {
            if (!credit.montant || credit.montant !== 0)
                return credit.montant + sum;
            return sum;
        }, 0);

        this.seriesPlanFinancement.push(creditBancaire);
    },
    data() {
        return {
            investorProgrammeOptions: {
                labels: [
                    "Immobilisations en non-valeur",
                    "Immobilisations corporelles"
                ],
                colors: ["#009fe3", "#1a9dd9", "#14b5ea", "#84d0f5", "#0d406b"],
                chart: {
                    type: "pie"
                },
                plotOptions: {
                    pie: {
                        // customScale: 0.3,
                        donut: {
                            labels: {
                                show: false,
                                name: {},
                                total: {
                                    show: true,
                                    label: "Total",
                                    color: "#373d3f",
                                    formatter: function(w) {
                                        return w.globals.seriesTotals.reduce(
                                            (a, b) => {
                                                return a + b;
                                            },
                                            0
                                        );
                                    }
                                }
                            }
                        }
                    }
                },
                dataLabels: {
                    formatter(val, opts) {
                        const name = opts.w.globals.labels[opts.seriesIndex];
                        return [name, val.toFixed(1) + "%"];
                    }
                },
                legend: {
                    formatter: function(seriesName, opts) {
                        return [
                            seriesName,
                            " - ",
                            opts.w.globals.series[opts.seriesIndex],
                            " DH"
                        ];
                    },
                    position: "bottom",
                    fontSize: "16px",
                    fontFamily: "Cormorant Garamond",
                    fontWeight: 400,
                    show: false
                }
            },
            investorProgrammeSeries: [],
            optionsPlanFinancement: {
                labels: [
                    "Capital social",
                    "Apport en comptes courants associés",
                    "Leasing",
                    "Crédit bancaire"
                ],
                colors: ["#009fe3", "#1a9dd9", "#14b5ea", "#84d0f5", "#0d406b"],
                chart: {
                    type: "pie"
                },
                plotOptions: {
                    pie: {
                        // customScale: 0.3,
                        donut: {
                            labels: {
                                show: false,
                                name: {},
                                total: {
                                    show: true,
                                    label: "Total",
                                    color: "#373d3f",
                                    formatter: function(w) {
                                        return w.globals.seriesTotals.reduce(
                                            (a, b) => {
                                                return a + b;
                                            },
                                            0
                                        );
                                    }
                                }
                            }
                        }
                    }
                },
                dataLabels: {
                    formatter(val, opts) {
                        const name = opts.w.globals.labels[opts.seriesIndex];
                        return [name, val.toFixed(1) + "%"];
                    }
                },
                legend: {
                    formatter: function(seriesName, opts) {
                        return [
                            seriesName,
                            " - ",
                            opts.w.globals.series[opts.seriesIndex],
                            " DH"
                        ];
                    },
                    position: "bottom",
                    fontSize: "16px",
                    fontFamily: "Cormorant Garamond",
                    fontWeight: 400,
                    show: false
                }
            },
            seriesPlanFinancement: []
        };
    },
    computed: {
        ImmobilisationsEnNonValeur() {
            return this.investorProgramme.ITMO.filter(
                item =>
                    item.name === "Frais d'etude" ||
                    item.name === "Frais de garanties" ||
                    item.name === "Droits de douane" ||
                    item.name === "Formation" ||
                    item.name === "Transit" ||
                    item.name === "Installation"
            ).reduce((a, b) => a + b.value, 0);
        },
        ImmobilisationsCorporelles() {
            return this.investorProgramme.ITMO.filter(
                item =>
                    item.name === "ITMO" ||
                    item.name === "Transport" ||
                    item.name === "Installation" ||
                    item.name === "Aménagement et agencement"
            ).reduce((a, b) => a + b.value, 0);
        }
    },
    methods: {}
};
</script>

<style></style>
